import { API } from '../api'
import { ContractsResponse } from './interface'

export const patch = async (
  filtros: Record<string, any>
): Promise<{
  conteudo: string
  sucesso: boolean
}> => {
  try {
    const { contractId, ...filtrosRest } = filtros
    const response = await API.patch<ContractsResponse>(
      `/contratos/${contractId}/status`,
      filtrosRest
    )

    return {
      conteudo: response?.content,
      sucesso: response?.isSuccess
    }
  } catch (error) {
    console.error('Erro ao solicitar alteração:', error)
    return {
      conteudo: error,
      sucesso: false
    }
  }
}
